<template>
  <div class="commonFoot">
    <div class="commonFoot_1">更多精彩 联系我们</div>
    <div class="commonFoot_2">
      <div class="commonFoot_2_one">
        <div class="commonFoot_2_one_1">
          <div class="commonFoot_2_one_1_one">即刻关注</div>
          <div class="commonFoot_2_one_1_two">微信扫码关注我们</div>
        </div>
        <div class="commonFoot_2_one_2">
          <img :src="info.wechathao || info.dxr_wechatgongzhong" class="commonFoot_2_one_2_one" alt="">
          <div class="commonFoot_2_one_2_two">企业公众号</div>
        </div>
        <div class="commonFoot_2_one_2">
          <img :src="info.wechatgongzhong || info.dxr_wechathao" class="commonFoot_2_one_2_one" alt="">
          <div class="commonFoot_2_one_2_two">企业微信号</div>
        </div>
      </div>
      <div class="commonFoot_2_two">
        <div class="commonFoot_2_two_one">
          <div class="commonFoot_2_two_one_1">企业电话</div>
          <div class="commonFoot_2_two_one_2">{{info.tel || info.dxr_tel}}</div>
        </div>
        <img src="@/assets/img/logo_1.png" class="commonFoot_2_two_two" alt="" v-if="type == 1">
        <img src="@/assets/img/t_2.png" class="commonFoot_2_two_two" alt="" v-if="type == 2">
      </div>
    </div>
    <div class="commonFoot_3">
      <img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt="">
      <a href="https://beian.miit.gov.cn" rel="noreferrer" target="_blank">备案号：<span
          style="cursor: pointer; margin-left: -5px">冀ICP备2025100585号</span></a>
    </div>
  </div>
</template>

<script>
  // Created by www.xingnuocn.com
  // @title: 详情底部
  // @author: 刘嘉鑫
  export default {
    props: {
      type: String, // 1:公司介绍  2:汰汰清单详情  3:打单详情
    },
    data() {
      return {
        info: "",
      }
    },
    mounted() {
      this.getInfo()
    },
    methods: {
      // 详情
      getInfo() {
        let url;
        if (this.type == 1 || this.type == 2) {
          url = "/Index/index"
        }
        if (this.type == 3) {
          url = "/Index/getDxrInfo"
        }
        this.$request({
          url: url,
        }).then((res) => {
          // console.log("详情", res);
          this.info = res;
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  .commonFoot {
    background: linear-gradient(180deg, #EFF7FF 0%, #E6ECF4 100%);
    padding: 106px 160px 20px;

    .commonFoot_1 {
      font-weight: 500;
      font-size: 42px;
      color: #2A303A;
      text-align: center;
      margin-bottom: 76px;
      letter-spacing: 3px;
    }

    .commonFoot_2 {
      display: flex;
      justify-content: space-between;
      margin-bottom: 80px;

      .commonFoot_2_one {
        width: 43%;
        background: #FFFFFF;
        border-radius: 40px;
        padding: 40px 155px 50px 120px;
        display: flex;
        align-items: center;

        .commonFoot_2_one_1 {
          .commonFoot_2_one_1_one {
            font-weight: 700;
            font-size: 28px;
            color: #333A47;
            margin-bottom: 36px;
            letter-spacing: 3px;
          }

          .commonFoot_2_one_1_two {
            font-weight: 400;
            font-size: 20px;
            color: #5D6574;
            letter-spacing: 2px;
          }
        }

        .commonFoot_2_one_2 {
          margin-left: auto;

          .commonFoot_2_one_2_one {
            width: 120px;
            height: 120px;
            background: #FFFFFF;
            border-radius: 20px;
            border: 4px solid #EFF7FF;
            padding: 6px;
            margin-bottom: 10px;
          }

          .commonFoot_2_one_2_two {
            font-weight: 400;
            font-size: 16px;
            color: #222222;
            text-align: center;
            letter-spacing: 2px;
          }
        }
      }

      .commonFoot_2_two {
        width: 25.3%;
        background: #FFFFFF;
        border-radius: 40px;
        display: flex;
        align-items: center;
        padding: 0 80px 0 110px;

        .commonFoot_2_two_one {
          .commonFoot_2_two_one_1 {
            font-weight: 700;
            font-size: 28px;
            color: #333A47;
            margin-bottom: 37px;
            letter-spacing: 2px;
          }

          .commonFoot_2_two_one_2 {
            font-weight: 700;
            font-size: 22px;
            color: #0057FE;
            letter-spacing: 3px;
          }
        }

        .commonFoot_2_two_two {
          width: 93px;
          height: 93px;
          margin-left: auto;
        }
      }
    }
  }

  .commonFoot_3 {
    padding: 20px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      font-weight: 400;
      font-size: 16px;
      color: #666;
      text-decoration: none;
    }

    img {
      width: 16px;
      margin-right: 10px;
      object-fit: contain;
    }
  }
</style>
